import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-8" data-testid="payment-cancel-page">
      <XCircle size={64} className="mx-auto text-clay" />
      <h1 className="mt-6 font-script text-3xl font-semibold text-cocoa">Pago cancelado</h1>
      <p className="mt-4 text-clay">
        No se realizó ningún cargo. Tu carrito sigue guardado por si quieres intentarlo de nuevo.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Button asChild className="rounded-full bg-habanero px-8 py-6 font-bold text-white hover:bg-habanero-dark" data-testid="cancel-retry-button">
          <Link to="/checkout">Volver al checkout</Link>
        </Button>
        <Button asChild variant="outline" className="rounded-full border-sand px-8 py-6 font-bold text-cocoa" data-testid="cancel-shop-button">
          <Link to="/tienda">Volver a la tienda</Link>
        </Button>
      </div>
    </div>
  );
}
